export const urlMapper = {
  DEAL: '/opportunities/',
  COMPANY: '/companies/',
  CONTACT: '/contacts/'
}
